<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedHireStatuses"
      multi-select
      searchable
      :label="$t('Hire status')"
      :list="hireStatuses"
      :placeholder="$t('Select a hire status to filter by')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { HireActiveStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedHireStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const orderedStatuses = [
  HireActiveStatus.Draft,
  HireActiveStatus.Offered,
  HireActiveStatus.Active,
  HireActiveStatus.Signed,
  HireActiveStatus.Ended,
  HireActiveStatus.Terminated,
  HireActiveStatus.Cancelled,
]

const hireStatuses = computed(() =>
  orderedStatuses.map((status) => ({
    label: $t(
      Object.keys(HireActiveStatus).find(
        (key) => HireActiveStatus[key as keyof typeof HireActiveStatus] === status,
      ) || status,
    ),
    value: status,
  })),
)
</script>
